import { ConformityGenerateModuleV2 } from "../conformity/ConformityGenerateModuleV2"

/** Customer Studio · Conformity — generate Declarations of Conformity.
 *  v2 (one document per scope, all frameworks) is the only version; whether an
 *  org sees this page at all is MC_CUSTOMER_STUDIO_CONFORMITY's job. */
export function ConformityPage() {
  return <ConformityGenerateModuleV2 />
}
